const API_BASE = process.env.REACT_APP_API_BASE_URL || ''

export class ApiError extends Error {
  constructor(message, { status, body } = {}) {
    super(message)
    this.name = 'ApiError'
    this.status = status
    this.body = body
  }
}

export function withApiBase(path) {
  if (!path.startsWith('/')) return `${API_BASE}/${path}`
  return `${API_BASE}${path}`
}

export async function apiFetch(path, options = {}) {
  const res = await fetch(withApiBase(path), {
    ...options,
    headers: {
      ...(options.headers || {}),
    },
  })

  if (res.ok) return res

  let bodyText = null
  try {
    bodyText = await res.text()
  } catch {
    bodyText = null
  }

  throw new ApiError(`Request failed: ${res.status} ${res.statusText}`, {
    status: res.status,
    body: bodyText,
  })
}

export async function apiJson(path, options = {}) {
  const res = await apiFetch(path, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      ...(options.headers || {}),
    },
  })

  return res.json()
}
